import { render, staticRenderFns } from "./sidebar_workspace_item.vue?vue&type=template&id=4fcafec1&scoped=true&"
import script from "./sidebar_workspace_item.vue?vue&type=script&lang=js&"
export * from "./sidebar_workspace_item.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_workspace_item.vue?vue&type=style&index=0&id=4fcafec1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcafec1",
  null
  
)

export default component.exports